/* ============
 * EmailSetup Page
 * ============
 *
 * Ask for the email only as the get started page
 */
import Forms from './../../../utils/forms/forms';
import accountTransformer from './../../../transformers/custom/accountSetup';
import checkBusinessTransformer from './../../../transformers/custom/checkBusiness';
import authService from './../../../services/auth';

export default {
  data() {
    return {
      form: new Forms({
        email: {
          value: '',
          type: 'email',
          required: true,
          maxlength: 10,
        },
        businessRegistrationNumber: {
          value: '',
          type: 'text',
        },
      }),
      finalStep: new Forms({
        businessRegistrationNumber: {
          value: '',
          type: 'text',
        },
        businessName: {
          value: '',
          type: 'text',
        },
        email: {
          value: '',
          type: 'email',
        },
        mobile: {
          value: '',
          type: 'float',
        },
        address: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'float',
        },
        city: {
          value: '',
          type: 'text',
        },
        isVatRegistered: {
          value: false,
          type: 'checkbox',
        },
        isRegisteredBusinessEnterprise: {
          value: false,
          type: 'checkbox',
        },
        marketingAllowed: {
          value: false,
          type: 'checkbox',
        },
        tosAccepted: {
          value: false,
          type: 'term',
        },
      }),
      step: 1,
    };
  },

  mounted() {
    console.log(this.$route.params.plan);
    if (this.$route.params.plan !== 'edi' && this.$route.params.plan !== 'booking') {
      this.form.hideField('businessRegistrationNumber');
    }
    if (this.$route.params.plan === 'edi' && this.$route.params.plan !== 'booking') {
      this.finalStep.disableField('businessRegistrationNumber');
    }
  },

  computed: {
    /*
     * Determines the message to display on the top of the form.
     */
    headerMessage1() {
      return `${this.$t('static.emailSetup.headerMessage1')}
      ${this.$t(`static.emailSetup.${this.$route.params.plan}`)}`;
    },
    headerMessage2() {
      return `${this.$t('static.emailSetup.headerMessage2')}`;
    },
    /*
     * Determines the if the login instead should show or not.
     */
    loginInstead() {
      if ((this.form.errors.errors && this.form.errors.errors.email) && (this.form.errors.errors.email[0] === 'email er allerede i bruk.' || this.form.errors.errors.email[0] === 'email has already been taken.')) {
        return true;
      }

      return false;
    },
  },

  watch: {
    'form.email': function (value) {
      this.form.email = value.replace(/\s+/g, '');
    },
  },

  methods: {

    /**
     * This method will be called when the form was submitted.
     */
    next() {
      this.form.loading = true;
      // if (!this.form.businessRegistrationNumber.trim()){
      //   this.finalStep.hideField('businessRegistrationNumber');
      //   this.step = 2;
      //   this.finalStep.email = this.form.email;
      //   this.form.loading = false;
      //   return;
      // }
      const business = checkBusinessTransformer.send(this.form.data());
      authService.checkBusiness(business)
        .then((response) => {
          this.form.loading = false;
          this.finalStep.businessRegistrationNumber = this.form.businessRegistrationNumber;
          this.finalStep.businessName = response.businessName;
          this.finalStep.email = this.form.email;
          this.finalStep.address = response.address;
          this.finalStep.postalCode = response.postalCode;
          this.finalStep.city = response.city;
          this.finalStep.country = response.country;
          this.finalStep.isVatRegistered = response.isVatRegistered;
          this.finalStep.isRegisteredBusinessEnterprise = response.isRegisteredBusinessEnterprise;
          this.step = 2;
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },

    /**
     * This method will be called when the form was submitted.
     */
    register() {
      if (!this.finalStep.tosAccepted) {
        this.$alert(`${this.$t('static.accountSetup.termsError')}`);
        return false;
      }
      this.finalStep.loading = true;
      this.finalStep.plan = this.$route.params.plan;
      this.finalStep.type = this.$route.query.type;
      const account = accountTransformer.send(this.finalStep.data());
      authService.registerEmail(account)
        .catch((errors) => {
          this.finalStep.loading = false;
          this.finalStep.recordErrors(errors);
        });
    },

  },

  components: {
    VForm: require('./../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/register/emailSetup/emailSetup.js